import React, {Component} from 'react';
import Slider from 'rc-slider';
import {doubletapSelect} from '../../../helpers/doubleTapHelper';

import 'rc-slider/assets/index.css';

import PropTypes from "prop-types";

export default class BudgetSlider extends Component {
  static propTypes = {
    unit: PropTypes.string,
    max: PropTypes.number,
    ignoreMax: PropTypes.bool,
    min: PropTypes.number,
    value: PropTypes.number,
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    max: 0,
    min: 0,
    ignoreMax: false,
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.setValue = this.setValue.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  setValue(val, target) {
    if (this.props.disabled) return false;
    let value = parseInt(val, 10) || 0 ;
    if (!this.props.ignoreMax && value > this.props.max) value = this.props.max;
    if (value < this.props.min) value = this.props.min;
    if(target) target.value = value;
    this.props.customOnChange(this.props.onChangeKey, value);
  }

  onBlur(e) {
    if (this.props.disabled) return false;
    this.focussed = false;
    if (e.target.value === '' || e.target.value === null) {
      e.target.value = this.props.value;
    }
    this.setValue(e.target.value.replace(',', '.'), e.target);
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return !this.focussed;
  }

  render() {
    let valueMain;
    let valueSecond;
    let { suffix, min, max, value, twoValueSlider } = this.props;
    if(!value && value !== 0)
      value = Math.floor(((max - min) / 2) + min);
    if (twoValueSlider) {
      valueSecond = value;
      valueMain = max - parseInt(valueSecond, 10);
    } else {
      valueMain = value;
    }

    if(this.secondInput) this.secondInput.value = valueSecond;
    if(this.input) this.input.value = valueMain;


    return (
      <div className={'slider-container' + (this.props.twoValueSlider ? ' two-value' : '') + (suffix ? ' suffix' : '') + (this.props.role === 'groupmember' ? ' groupmember-disabled' : '') + (this.props.disabled ? ' disabled' : '')}>

        {
          this.props.titles ?
            <div className={'slider-titles'}>
              <p>{this.props.titles[0]}</p>
              <p>{this.props.titles[1]}</p>
            </div>
          : null
        }

        { this.props.twoValueSlider ?
          <div className="budget-input-wrapper">
            <input
              type='number'
              min={this.props.min}
              max={this.props.ignoreMax ? Infinity : this.props.max}
              onChange={(ev) => {
                if (this.props.disabled) return false;
                if (parseInt(ev.target.value, 10) > this.props.max && !this.props.ignoreMax) {
                  ev.target.value = this.props.max;
                }
                this.setValue(ev.target.value, null);
              }}
              onFocus={(ev)=> {
                this.focussed = true;
                ev.target.value = null;
              }}
              onBlur={this.onBlur}
              onClick={(ev) => doubletapSelect(ev)}
              defaultValue={valueSecond}
              ref={ref=>this.secondInput = ref}
              pattern="[0-9]*"
              className={'value-container'}
            />
            {suffix ? <div className="budget-input-suffix">{suffix}</div> : null}
          </div>
        : null }

        <Slider
          min={(this.props.min ? this.props.min : 0)}
          max={this.props.max}
          defaultValue={value}
          value={(value > this.props.max ? this.props.max : value)}
          onChange={(ev) => { if (this.props.disabled) return false; this.setValue(parseInt(ev, 10), null); }}
        />
        <div className="budget-input-wrapper">
          <input
            type='number'
            min={this.props.min}
            max={this.props.ignoreMax ? Infinity : this.props.max}
            onChange={(ev) => {
              if (this.props.disabled) return false;
              if (parseInt(ev.target.value, 10) > this.props.max && !this.props.ignoreMax) {
                ev.target.value = this.props.max;
              }
              this.setValue(ev.target.value, null);
            }}
            onClick={(ev) => doubletapSelect(ev)}
            onFocus={(ev)=> {
              this.focussed = true;
              ev.target.value = null;
            }}
            onBlur={this.onBlur}
            defaultValue={valueMain}
            ref={ref=>this.input = ref}
            disabled={this.props.twoValueSlider}
            pattern="[0-9]*"
            className={'value-container'}/>
          {
            this.props.unit ?
              <span title={this.props.unit}>{this.props.unit}</span>
            : null
          }
          {suffix ? <div className="budget-input-suffix">{suffix}</div> : null}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/StepThree/BudgetSlider.js